import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StorageComponent } from './storage/storage.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    StorageComponent
  ],
})
export class SharedStorageModule {}
